<style lang="scss">
  @import "product-listing";
</style>

<script>
import Product from '../product-category-list/product-category-list'
import { CONSTANT } from '../../../utils/constant'

export default {
  components: {
    'app-product': Product
  },
  data () {
    return {
      CONSTANT: CONSTANT
    }
  },
  methods: {
    /**
       * This method routes to Home Page
       */
    homePage () {
      this.$router.push('/').catch(err => { console.error(err) })
    }
  }
}
</script>

<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col">
        <h3 class="mt-3">
          {{ CONSTANT.CONFIG.PRODUCT_NAVIGATION_LIST.join(" | ") }}
        </h3>
      </div>
    </div>
    <div class="border-dark border-top my-2" />
    <div class="row m-0 pt-2">
      <div class="col-lg-8 col-sm-12 p-0">
        <ol class="breadcrumb bg-white p-0">
          <li
            class="breadcrumb-item text-primary btn p-0 border-0"
            @click="homePage()"
          >
            {{ $t ('label.home') }}
          </li>
          <li class="breadcrumb-item">
            {{ $t ('label.viewProducts') }}
          </li>
        </ol>
      </div>
      <div class="col-lg-4 text-lg-right col-sm-12 p-0">
        <span class="mr-1">
          {{ $t ('label.sortBy') }}
        </span>
        <span class="ml-1">
          {{ $t ('label.relevance') }}
        </span>
      </div>
    </div>
    <app-product />
  </div>
</template>
